import React from 'react'
import ClassCard from '../../../Components/Cards/ClassCard'
import { getWeekNumber } from '../../../App/Course/Helpers/Timings'
import { H5 } from '../../../Styles/typography'

const Week = ({
  data,
  weekIndex,
  index,
  initiateReschedule,
  userType,
  batchId,
}) => (
  <div className='week'>
    {parseInt(weekIndex) === getWeekNumber(new Date()) ? (
      <H5 bold>This Week</H5>
    ) : (
      <H5 bold>Week {index + 1}</H5>
    )}
    <div className='classes'>
      {data.map((classData, i) => {
        return (
          <ClassCard
            classId={classData.id}
            key={weekIndex + 'classCard' + i}
            start={new Date(classData.startTime)}
            status={classData.makeupClass ? 'MAKEUP' : classData.status}
            end={new Date(classData.endTime)}
            index={classData.index}
            totalClasses={classData.totalClasses}
            rating={classData.rating}
            recordingId={classData?.recordingId}
            initiateReschedule={() => initiateReschedule(classData)}
            userType={userType}
            batchId={batchId}
          />
        )
      })}
    </div>
  </div>
)

export default Week
